function HydroATermomechanika(){
    return(
        <div>
            HydroATermomechanika
        </div>
    );
};

export default HydroATermomechanika;